import FundDetailsValues from './FundDetailsValues'

export default FundDetailsValues
